export enum SWITCHER_STATES {
    LOGO_SERVICES = 'logo_services',
    LOGO_MAKER = 'logo_maker',
}

export const ENTRY_POINT_CLICKED = {
    [SWITCHER_STATES.LOGO_SERVICES]: 'Logo design',
    [SWITCHER_STATES.LOGO_MAKER]: 'Logo maker',
} as const;
